import { Icon } from './_Icon';
export const CodeIcon = (props) => (
  <Icon {...props} d="M16 18l6-6-6-6 M8 6l-6 6 6 6" />
);
